import { render, staticRenderFns } from "./gruppenauswahl.vue?vue&type=template&id=2f6282aa&scoped=true&"
import script from "./gruppenauswahl.vue?vue&type=script&lang=js&"
export * from "./gruppenauswahl.vue?vue&type=script&lang=js&"
import style0 from "./gruppenauswahl.vue?vue&type=style&index=0&id=2f6282aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6282aa",
  null
  
)

export default component.exports